// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0a0a0f',
      paper: '#111118',
    },
    primary: {
      main: '#d4a550',
      light: '#f0c878',
      dark: '#8b5e1a',
      contrastText: '#0a0a0f',
    },
    secondary: {
      main: '#60a5fa',
      contrastText: '#0a0a0f',
    },
    error: {
      main: '#f87171',
    },
    warning: {
      main: '#fbbf24',
    },
    success: {
      main: '#4ade80',
    },
    text: {
      primary: '#f0ece4',
      secondary: '#8a8a9a',
      disabled: '#4a4a5a',
    },
    divider: 'rgba(255,255,255,0.07)',
    action: {
      hover: 'rgba(255,255,255,0.05)',
      selected: 'rgba(212,165,80,0.12)',
      disabled: 'rgba(255,255,255,0.2)',
    },
  },

  typography: {
    fontFamily: [
      'Inter',
      'system-ui', '-apple-system', 'Segoe UI', 'Roboto',
      'Helvetica Neue', 'Arial', 'Noto Sans'
    ].join(','),
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h6: { fontWeight: 700, letterSpacing: 0.2 },
    button: { textTransform: 'none', fontWeight: 600, letterSpacing: 0.2 },
  },

  shape: {
    borderRadius: 10,
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#111118',
          border: '1px solid rgba(255,255,255,0.07)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#111118',
          border: '1px solid rgba(255,255,255,0.07)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
        outlined: {
          borderColor: 'rgba(255,255,255,0.12)',
          '&:hover': {
            borderColor: '#d4a550',
            color: '#d4a550',
            backgroundColor: 'rgba(212,165,80,0.08)',
          },
        },
        contained: {
          backgroundColor: '#d4a550',
          color: '#0a0a0f',
          '&:hover': {
            backgroundColor: '#f0c878',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(255,255,255,0.1)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(212,165,80,0.4)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#d4a550',
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255,255,255,0.07)',
        },
        head: {
          fontWeight: 600,
          color: '#8a8a9a',
          fontSize: '0.75rem',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255,255,255,0.08)',
          borderRadius: 4,
        },
        bar: {
          backgroundColor: '#d4a550',
          borderRadius: 4,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255,255,255,0.07)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#18181f',
          border: '1px solid rgba(255,255,255,0.1)',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#18181f',
          border: '1px solid rgba(255,255,255,0.1)',
          fontSize: '0.75rem',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-selected': {
            backgroundColor: 'rgba(212,165,80,0.12)',
            '&:hover': {
              backgroundColor: 'rgba(212,165,80,0.18)',
            },
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(212,165,80,0.2)',
          color: '#d4a550',
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
